export default __webpack_public_path__ + "static/media/Background_00216.33e3a7d1.png";